import UserRights from '@/models/loyaltyPanel/UserRights';
const getDefaultState = () => ({
  users: [],
  defaultPermissions: {
    default_company_cms: {},
    default_store_cms: {},
  },
  user: new UserRights(),
  roles: [],
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setUsers(state, payload) {
      state.users = payload;
    },

    setUser(state, payload) {
      state.user = new UserRights(payload);
    },

    setDefaultPermissions(state, payload) {
      state.defaultPermissions = payload;
    },

    setRoles(state, payload) {
      state.roles = payload;
    },
  },

  actions: {
    async getUsers({ commit, dispatch }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await UserRights.get(query);
        const { users, pagination } = data.data;
        commit('setUsers', users);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getDefaultPermissions({ commit }) {
      try {
        const { data } = await UserRights.getDefaultPermissions();
        commit('setDefaultPermissions', data.data);
      } catch (ex) {
        console.error(ex.response?.data);
        console.error(ex);
      }
    },

    async create({ commit, dispatch, rootState }, user) {
      try {
        commit('setLoading', true, { root: true });

        delete user.user_id;
        user.permissions = [user.permissions];

        const { data } = await UserRights.create(user);
        data.data.permissions = user.permissions[0];

        commit('setServerItemsLength', rootState.serverItemsLength + 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        let query = '?page=1';
        dispatch('getUsers', query);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created store moderator!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async update({ commit, state, rootState }, user) {
      try {
        commit('setLoading', true, { root: true });
        user.permissions = [user.permissions];

        const { data } = await UserRights.update(user);
        data.data.permissions = user.permissions[0];

        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated store moderator!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async upgrade({ commit, state, rootState }, user) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await UserRights.upgrade(user.user_account_id);
        data.data.permissions = user.permissions[0];

        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully upgraded the user!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async downgrade({ commit, state, rootState }, user) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await UserRights.downgrade(user.user_account_id);
        data.data.permissions = user.permissions[0];

        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully downgraded the user!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async delete({ commit, state, rootState }, user) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await UserRights.delete(user.user_account_id);
        data.data.permissions = user.permissions[0];

        commit('setServerItemsLength', rootState.serverItemsLength - 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully deleted the user!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async getRoles({ commit }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await UserRights.getRoles();

        commit('setRoles', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },
  },
};
